// Quelle: Plans/PPC_LAGER_CODES_REFERENZ.md
// Stand: 2026-04-30 — 60 Codes in 8 Kategorien.
// Beim Editieren auch die Markdown-Quelle aktualisieren.

export interface PpcCode {
  code: string
  categoryNumber: string
  category: string
  lager: string
  sku?: string
}

export const PPC_CODE_REGEX = /^\d{2}_[A-Z]{2,5}$/

export const PPC_CODES: ReadonlyArray<PpcCode> = [
  { code: '01_FGR', categoryNumber: '01', category: 'GRIFFE', lager: 'Fenstergriffe' },
  { code: '01_HGR', categoryNumber: '01', category: 'GRIFFE', lager: 'Handgriff' },
  { code: '01_MGR', categoryNumber: '01', category: 'GRIFFE', lager: 'Möbelgriffe' },
  { code: '01_TGL', categoryNumber: '01', category: 'GRIFFE', lager: 'Türgriffe Langschild' },
  { code: '01_TGR', categoryNumber: '01', category: 'GRIFFE', lager: 'Türgriffe' },
  { code: '02_GAH', categoryNumber: '02', category: 'HAKEN', lager: 'Garderobenhaken' },
  { code: '02_HAL', categoryNumber: '02', category: 'HAKEN', lager: 'Hakenleisten' },
  { code: '02_THL', categoryNumber: '02', category: 'HAKEN', lager: 'Türhakenleiste' },
  { code: '02_KLH', categoryNumber: '02', category: 'HAKEN', lager: 'Klebehaken' },
  { code: '02_WAH', categoryNumber: '02', category: 'HAKEN', lager: 'Wandhaken' },
  { code: '03_GDF', categoryNumber: '03', category: 'SCHARNIERE_HARDWARE', lager: 'Gasdruckfeder' },
  { code: '03_RGT', categoryNumber: '03', category: 'SCHARNIERE_HARDWARE', lager: 'Regalträger' },
  { code: '03_SCH', categoryNumber: '03', category: 'SCHARNIERE_HARDWARE', lager: 'Scharniere' },
  { code: '03_SCN', categoryNumber: '03', category: 'SCHARNIERE_HARDWARE', lager: 'Schienen' },
  { code: '03_SRB', categoryNumber: '03', category: 'SCHARNIERE_HARDWARE', lager: 'Schrauben' },
  { code: '03_TSC', categoryNumber: '03', category: 'SCHARNIERE_HARDWARE', lager: 'Türschließer' },
  { code: '04_LWK', categoryNumber: '04', category: 'KOSMETIK', lager: 'Lockenwickler' },
  { code: '04_PAP', categoryNumber: '04', category: 'KOSMETIK', lager: 'Papilotten' },
  { code: '05_ALU', categoryNumber: '05', category: 'FUSSE_BEINE', lager: 'ALU LIGHT' },
  { code: '05_CHR', categoryNumber: '05', category: 'FUSSE_BEINE', lager: 'CHROM 48' },
  { code: '05_GLO', categoryNumber: '05', category: 'FUSSE_BEINE', lager: 'GLORIA 30' },
  { code: '05_GRA', categoryNumber: '05', category: 'FUSSE_BEINE', lager: 'GRANDA ≈50' },
  { code: '05_HNB', categoryNumber: '05', category: 'FUSSE_BEINE', lager: 'Haarnadelbeine' },
  { code: '05_SCA', categoryNumber: '05', category: 'FUSSE_BEINE', lager: 'SCALA' },
  { code: '05_SCP', categoryNumber: '05', category: 'FUSSE_BEINE', lager: 'SCALA PRO' },
  { code: '05_TIB', categoryNumber: '05', category: 'FUSSE_BEINE', lager: 'Tischbeine' },
  { code: '05_VIG', categoryNumber: '05', category: 'FUSSE_BEINE', lager: 'VIGO' },
  { code: '06_BTL', categoryNumber: '06', category: 'PLASTIK', lager: 'Beutel' },
  { code: '06_FNA', categoryNumber: '06', category: 'PLASTIK', lager: 'Fliegennetz Alu' },
  { code: '06_FNE', categoryNumber: '06', category: 'PLASTIK', lager: 'Fliegennetz Edelstahl' },
  { code: '06_FGT', categoryNumber: '06', category: 'PLASTIK', lager: 'Fliegengitter Tür' },
  { code: '06_FGF', categoryNumber: '06', category: 'PLASTIK', lager: 'Fliegengitter Fenster' },
  { code: '06_FGFIB', categoryNumber: '06', category: 'PLASTIK', lager: 'Fliegengitter Fiberglas' },
  { code: '06_POL', categoryNumber: '06', category: 'PLASTIK', lager: 'Polierpaste' },
  { code: '06_TTA', categoryNumber: '06', category: 'PLASTIK', lager: 'Torte Trends Artikel' },
  { code: '06_VAB', categoryNumber: '06', category: 'PLASTIK', lager: 'Vogelabwehr' },
  { code: '07_KOF', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Koffer Sets' },
  { code: '07_MUT', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Muttern' },
  { code: '07_FLM', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Flügelmuttern' },
  { code: '07_HUM', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Hutmuttern' },
  { code: '07_RAM', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Rändelmutter' },
  { code: '07_SSM', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Selbstsichernde Muttern' },
  { code: '07_SZM', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Sperrzahnmutter' },
  { code: '07_SKM', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Sechskantmutter DIN934' },
  { code: '07_GWM', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Gewindemuffe' },
  { code: '07_STR', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Stellringe' },
  { code: '07_DSC', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Dichtscheibe' },
  { code: '07_FER', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Federringe' },
  { code: '07_KSC', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Karosseriescheiben' },
  { code: '07_ROS', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Rosette' },
  { code: '07_SNS', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Schnorrscheiben' },
  { code: '07_SCH', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Scheiben DIN125' },
  { code: '07_HZS', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Holzschrauben' },
  { code: '07_MBS', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Möbelschrauben' },
  { code: '07_SKS', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Sechskantschrauben' },
  { code: '07_SKSN', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Senkkopfschrauben' },
  { code: '07_SPG', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Spenglerschrauben' },
  { code: '07_ZKS', categoryNumber: '07', category: 'BEFESTIGUNGSTECHNIK', lager: 'Zylinderkopfschrauben' },
  { code: '08_KLB', categoryNumber: '08', category: 'VERPACKUNG', lager: 'Klebeband' },
  { code: '08_VSB', categoryNumber: '08', category: 'VERPACKUNG', lager: 'Versandbeutel' },
]

export function findPpcCode(code: string): PpcCode | undefined {
  return PPC_CODES.find((c) => c.code === code)
}

export function isValidPpcCodeFormat(code: string): boolean {
  return PPC_CODE_REGEX.test(code)
}

export function groupPpcCodesByCategory(): Record<string, PpcCode[]> {
  return PPC_CODES.reduce<Record<string, PpcCode[]>>((acc, entry) => {
    const key = `${entry.categoryNumber} ${entry.category}`
    if (!acc[key]) acc[key] = []
    acc[key].push(entry)
    return acc
  }, {})
}
